// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3hrsO","modalForm":"UpgradeEpcsModal_modalForm__24xf4","modalFooter":"UpgradeEpcsModal_modalFooter__2yCso"};